export default __webpack_public_path__ + "static/bg-370fb075ecbb59e657b28129e12935da.jpg";